<template>
  <el-dialog title="物料信息" width="90%" :visible="visible" :close-on-click-modal="false" @close="close()">
    <div class="el-dialog-div1">
      <div class="dialog-container">
        <el-form label-width="120px" class="UniformCss" style="padding-bottom: 120px;">
          <el-row>
            <el-col :span="8">
              <el-form-item label="物料号">
                <el-input v-model="orderMaterial.materialCode" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料名称">
                <el-input v-model="orderMaterial.materialName" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料类型">
                <el-select v-model="orderMaterial.materialType" disabled>
                  <el-option label="销售物料" value="1" />
                  <el-option label="礼品物料" value="2" />
                  <el-option label="宣传物料" value="3" />
                  <el-option label="其它" value="4" />
                  <el-option label="产品资料" value="5" />
                  <el-option label="手册" value="6" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料库存">
                <el-input v-model="orderMaterial.storage" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料说明">
                <el-input v-model="orderMaterial.wlsm" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申领单价">
                <el-input v-model="orderMaterial.price" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申领数量">
                <el-input v-model="orderMaterial.nums" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申领总金额">
                <el-input v-model="orderMaterial.totalSums" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申领备注">
                <el-input v-model="orderMaterial.applyRemarks" disabled />
                <!-- <el-input v-model="orderMaterial.remarks" disabled /> -->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="审批数量">
                <el-input v-model="orderMaterial.approveNums" :disabled="isdetail" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="审批总金额">
                <el-input v-model="orderMaterial.approveTotalSums" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="审批备注">
                <!-- <el-input v-model="orderMaterial.applyRemarks" clearable :disabled="isdetail" /> -->
                <a-textarea v-model="orderMaterial.approveRemarks" :disabled="isdetail" :rows="3" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <!-- <el-form-item label="物料图片">
                <div v-if="pictures != null">
                  <div v-for=" (pic, index) in pictures" :key="index" class="pic-box">
                    <el-image
                      style="width: 150px; height: 150px"
                      :src="pic"
                      fit="contain"
                    />
                  </div>
                </div>
              </el-form-item> -->

              <el-form-item label="物料图片">
                <div v-if="pictures != null">
                  <div v-for="(pic, index) in pictures" :key="index" class="pic-box">
                    <el-image
                      style="width: 150px; height: 150px"
                      :src="typeof pic === 'object' ? pic.url : pic"  
                      fit="contain"
                    />
                  </div>
                </div>
              </el-form-item>

              

            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="text-center">
      <vxe-button v-if="isdetail" @click="close()">关闭</vxe-button>
      <vxe-button v-if="!isdetail" @click="cancel()">取消</vxe-button>
      <vxe-button v-if="!isdetail" status="success" @click="saveMaterial()">保存</vxe-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: 'ApproveMaterialDialog',

  // eslint-disable-next-line vue/require-prop-types
  props: ['visible', 'orderMaterial', 'pictures', 'isdetail'],
  data() {
    return {
      material: {}
    }
  },
  computed: {
  },

  created() {
  },
  beforeMount() {},
  mounted() {},
  methods: {
    saveMaterial() {
      this.$emit('saveMaterial', this.orderMaterial)
    },
    cancel() {
      this.$emit('cancel')
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
.el-dialog-div1{
  width: 100%;
  height: 60vh;
  display: flex;
}
.dialog-container {
    width: 98%;
}
.text-center {
  text-align: center;
}

.pic-box {
  display: inline-block;
  padding: 5px;
}

</style>
